import { render, staticRenderFns } from "./WirteOffCode.vue?vue&type=template&id=12d8cf1c&scoped=true&"
import script from "./WirteOffCode.vue?vue&type=script&lang=js&"
export * from "./WirteOffCode.vue?vue&type=script&lang=js&"
import style0 from "./WirteOffCode.vue?vue&type=style&index=0&id=12d8cf1c&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d8cf1c",
  null
  
)

export default component.exports